(function() {
	'use strict';

	angular
	.module('hub', [
		'ngSanitize', 'ngAnimate', 'angularMoment', 'restangular', 'hljs',
		'ui.router', 'ui.bootstrap', 'ui.select',
		'toastr', 'angular-loading-bar', 'evalua.angular', 'caMenu', 'caLoadingOverlay', 'chart.js',
		'hubApi', 'hubAuth', 'hubChannelSettings', 'hubChannelTypes', 'hubCompanies', 'hubCustomers', 'hubDeliveries'
	])
	.filter('hbBytes', HbBytesFilter)
	.run(AppRun);

	// as seen in https://gist.github.com/thomseddon/3511330
	function HbBytesFilter() {
		return function(bytes, precision) {
			if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) { return '-'; }
			if (typeof precision === 'undefined') { precision = 1; }
			var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
				number = Math.floor(Math.log(bytes) / Math.log(1024));
			return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
		};
	}

	AppRun.$inject = ['TranslationService'];

    function AppRun(TranslationService) {
        TranslationService.loadTranslations('es');
    }
})();

(function() {
  'use strict';

  angular
    .module('hub')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

'use strict';

angular.module('hub')

.factory('FiltersService', FiltersService);

function FiltersService() {
  var service = {
    getFiltersFromCache: getFiltersFromCache,
    setFiltersInCache: setFiltersInCache,
    resetFiltersCache: resetFiltersCache
  };
  var filtersCache = {};

  return service;

  /**
   * Get the filter cache for the given state
   * @param {string} stateId
   * @return {array|null}
   */
  function getFiltersFromCache(stateId) {
    if (filtersCache[stateId] !== undefined) {
      return filtersCache[stateId];
    }
    return null;
  }

  /**
   * Set the filter cache for this state with
   * given filters
   * @param {string} stateId
   * @param {array} filters
   */
  function setFiltersInCache(stateId, filters) {
    if (filtersCache[stateId] === undefined) {
      filtersCache[stateId] = {};
    }
    filtersCache[stateId] = filters;
  }

  /**
   * Reset the filters cache to empty
   */
  function resetFiltersCache() {
    filtersCache = {};
  }
}

(function() {
  'use strict';

  angular
    .module('hub')
    .directive('filtering', Filtering);

  function Filtering() {
    return {
      templateUrl: 'app/components/filtering/filtering.html',
      restrict: 'E',
      scope: {
        config: '=',
        selectedDefault: '='
      },
      controller: FilteringController,
      controllerAs: 'vmFiltering'
    };
  }

  FilteringController.$inject = [
    '$state',
    '$scope',
    'FiltersService'
  ];
  /* @ngInject */
  function FilteringController(
    $state,
    $scope,
    FiltersService
  ) {
    var vmFiltering = this;
    vmFiltering.ui = {
      dateInput : false
    };
    vmFiltering.datepickerOptions = {
      startingDay : 1
    };
    vmFiltering.fields = [];
    vmFiltering.selectedField = null;
    vmFiltering.selectedValue = null;
    vmFiltering.addFilter = addFilter;
    vmFiltering.removeFilter = removeFilter;
    vmFiltering.openDatepicker = openDatepicker;
    vmFiltering.displayValue = displayValue;
    vmFiltering.activeFilters = FiltersService.getFiltersFromCache($state.current.name);
    vmFiltering.config = vmFiltering.activeFilters ? vmFiltering.activeFilters : $scope.config;
    if ($scope.selectedDefault !== null) {
        var index = _.findIndex(vmFiltering.config, {apiField: $scope.selectedDefault});
        vmFiltering.selectedField = vmFiltering.config[index];
    }

    /**
     * Adds a filter and then emits the event.
     */
    function addFilter() {
      if (vmFiltering.selectedField.selectedValues.indexOf(vmFiltering.selectedValue) === -1)  {
        vmFiltering.selectedField.selectedValues.push(vmFiltering.selectedValue);
      }
      vmFiltering.selectedField = null;
      vmFiltering.selectedValue = null;
      FiltersService.setFiltersInCache($state.current.name, vmFiltering.config);
      $scope.$emit('filtersUpdated', vmFiltering.config);
    }

    /**
     * Open the datepicker with the
     * given type name
     * @param {string} type
     */
    function openDatepicker(type) {
      vmFiltering.ui[type] = true;
    }

    /**
     * Removes a filter and then emits the event.
     * @param {Object} configEntry
     * @param {int} value
     */
    function removeFilter(configEntry, value) {
      configEntry.selectedValues.splice(configEntry.selectedValues.indexOf(value), 1);
      FiltersService.setFiltersInCache($state.current.name, vmFiltering.config);
      $scope.$emit('filtersUpdated', vmFiltering.config);
    }

    /**
     * Displays the text value, checking if it's a date
     * or just plain text, or get a display field.
     * @param {Object} configEntry
     * @param {string} value
     * @return {string}
     */
    function displayValue(configEntry, value) {
      if (configEntry.displayField) {
        return _.find(configEntry.values, {'id' : value})[configEntry.displayField];
      }
      return value;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('hub')
    .directive('hbDeliveryStatusLabel', HbDeliveryStatusLabel);

  /** @ngInject */
  function HbDeliveryStatusLabel(hbConstants) {
    var directive = {
      bindToController: true,
      controller: HbDeliveryStatusLabelController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        status: '='
      },
      templateUrl: 'app/components/delivery-status-label/delivery-status-label.html'
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  /** @ngInject */
  function HbDeliveryStatusLabelController(hbConstants) {
    var vm = this;

    vm.getLabelClass = getLabelClass;
    vm.getStatusName = getStatusName;

    activate();

    function activate() {
    }

    function getLabelClass() {
      switch (vm.status) {
        case hbConstants.get().DELIVERY_STATUS.QUEUED.id:
        default:
          return 'default';
        case hbConstants.get().DELIVERY_STATUS.IN_PROGRESS.id:
          return 'info';
        case hbConstants.get().DELIVERY_STATUS.DELIVERED.id:
          return 'success';
        case hbConstants.get().DELIVERY_STATUS.FAILED.id:
          return 'danger';
        case hbConstants.get().DELIVERY_STATUS.CANCELED.id:
          return 'warning';
        case hbConstants.get().DELIVERY_STATUS.AWAITING_COMPANY_RESPONSE.id:
          return 'primary';
      }
    }

    function getStatusName() {
      return hbConstants.byId('DELIVERY_STATUS', vm.status).name;
    }
  }
})();

(function() {
	'use strict';

	angular
		.module('hub')
		.directive('hbChannelStatusIcon', HbChannelStatusIcon);

	/** @ngInject */
	function HbChannelStatusIcon(hbConstants) {
		var directive = {
			bindToController: true,
			controller: HbChannelStatusIconController,
			controllerAs: 'vm',
			link: link,
			restrict: 'E',
			scope: {
				status: '='
			},
			templateUrl: 'app/components/channel-status-icon/channel-status-icon.html'
		};
		return directive;

		function link(scope, element, attrs) {
		}
	}

	/** @ngInject */
	function HbChannelStatusIconController(hbConstants) {
		var vm = this;

		vm.getTextClass = getTextClass;
		vm.getStatusName = getStatusName;

		activate();

		function activate() {
		}

		function getTextClass() {
			switch (vm.status) {
				case hbConstants.get().CHANNEL_STATUS.ONLINE.id:
					return 'success';
				case hbConstants.get().CHANNEL_STATUS.OFFLINE.id:
					return 'danger';
				default:
					return 'default';
			}
		}

		function getStatusName() {
			return hbConstants.byId('CHANNEL_STATUS', vm.status).name;
		}
	}
})();

(function() {
  'use strict';

  angular
    .module('hub')
    .factory('TranslationService', TranslationService);

  TranslationService.$inject = ['$http', '$q'];

  function TranslationService($http, $q) {
    var translations = {};

    return {
      loadTranslations: loadTranslations,
      translate: translate
    };

    function loadTranslations(locale) {
      var deferred = $q.defer();
      $http.get('assets/locale/' + locale + '.json')
        .then(function(response) {
          translations = response.data;
          deferred.resolve(translations);
        })
        .catch(function(error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function translate(key) {
      var keys = key.split('.');
      var value = translations;
      for (var i = 0; i < keys.length; i++) {
        value = value[keys[i]];
        if (!value) {
          break;
        }
      }
      return value || key;
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('hub')
    .filter('translate', TranslateFilter);

  TranslateFilter.$inject = ['TranslationService'];

  function TranslateFilter(TranslationService) {
    return function(key) {
      return TranslationService.translate(key);
    };
  }
})();
(function() {
	'use strict';

	angular
	.module('hub')
	.controller('MainController', MainController);

	/** @ngInject */
	function MainController($state, toastr, OAuthManager, hbSession, RevokeToken) {
		var vm = this;
		vm.hbSession = hbSession;

		vm.logout = logout;

		activate();

		function activate() {
		}

        function logout() {
            RevokeToken.post().then(function () {
                OAuthManager.logout();
                toastr.success('Has cerrado tu sesión con éxito');
                $state.go('root.login');
            });
        }
	}
})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries', ['naif.base64']);
})();

(function () {
  'use strict';

  angular
    .module('hubDeliveries')
    .controller('DeliveryDetailController', DeliveryDetailController)
    .controller('RepeatDeliveryConfirmationModalController', RepeatDeliveryConfirmationModalController);

  /** @ngInject */
  function DeliveryDetailController(
    $q,
    $uibModal,
    hbConstants,
    toastr,
    delivery,
    TranslationService) {
    var vm = this;
    vm.delivery = delivery;
    vm.constants = hbConstants.get();

    vm.canCancelDelivery = canCancelDelivery;
    vm.cancelDelivery = cancelDelivery;
    vm.canRepeatDelivery = canRepeatDelivery;
    vm.getErrorReasonLabelClass = getErrorReasonLabelClass;
    vm.getMetadataAsString = getMetadataAsString;
    vm.getResponseAsString = getResponseAsString;
    vm.getSettingOverridesAsString = getSettingOverridesAsString;
    vm.repeatDelivery = repeatDelivery;

    activate();

    function activate() {
    }

    /**
     * If the delivery has already been delivered,
     * shows a confirmation modal before repeating
     * the delivery and returns a promise with the
     * modal result.
     *
     * Otherwise this function returns a promise
     * which will be immediately resolved.
     *
     * @return {Promise}
     */
    function askForRepeatConfirmation() {
      // only ask for confirmation if delivery has already been delivered
      if (vm.delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.DELIVERED.id) {
        return $uibModal.open({
          controller: 'RepeatDeliveryConfirmationModalController',
          templateUrl: 'app/deliveries/repeat-delivery-confirmation-modal.html'
        }).result;
      }

      // otherwise just simulate the modal
      var deferred = $q.defer();
      deferred.resolve('ok');
      return deferred.promise;
    }

    /**
     * Returns whether the current delivery can
     * be canceled.
     *
     * @return {Boolean}
     */
    function canCancelDelivery() {
      return vm.delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.QUEUED.id;
    }

    /**
     * Cancels the current delivery.
     *
     * @return {Promise}
     */
    function cancelDelivery() {
      return vm.delivery.remove()
        .then(function () {
          vm.delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.CANCELED.id;
          toastr.success('El envío ha sido cancelado con éxito');
        });
    }

    /**
     * Returns whether the current delivery can
     * be repeated.
     *
     * @return {Boolean}
     */
    function canRepeatDelivery() {
      var deliveryStatusId = vm.delivery.delivery_status_id;
      if (deliveryStatusId === hbConstants.get().DELIVERY_STATUS.AWAITING_COMPANY_RESPONSE.id) {
        return vm.delivery.company.send_communication;
      }

      return [
        hbConstants.get().DELIVERY_STATUS.DELIVERED.id,
        hbConstants.get().DELIVERY_STATUS.FAILED.id,
        hbConstants.get().DELIVERY_STATUS.CANCELED.id
      ].indexOf(deliveryStatusId) >= 0;
    }

    function getMetadataAsString() {
      parseDeliveryMetadataIfNecessary();
      return JSON.stringify(delivery.metadata, null, 4);
    }

    function getResponseAsString() {
      parseDeliveryResponseIfNecessary();
      return JSON.stringify(delivery.response, null, 4);
    }

    function parseDeliveryMetadataIfNecessary() {
      if (delivery.origin === 'api') {
        return;
      }
      if ((!_.isNil(delivery.predecessor) &&
        delivery.predecessor.company_id !== hbConstants.get().COMPANY.CASER.id) ||
        _.isNil(delivery.predecessor)
      ) {
        return;
      }
      var str, parser, xmlDoc, responseMessage;
      str = delivery.metadata.response;
      str = str.replace(/(\\r\\n|\\n|\\r)/gm, '');
      str = str.replace(/\\/g, '');

      parser = new DOMParser();
      xmlDoc = parser.parseFromString(str, 'text/html');
      if (!xmlDoc.getElementsByTagName('salida').length) {
        return;
      }
      responseMessage =
        (xmlDoc.getElementsByTagName('salida')[0].firstChild.nodeValue)
          .replace(/(<([^>]+)>)/ig, '').trim();
      delivery.metadata.response = responseMessage;
    }

    function parseDeliveryResponseIfNecessary() {
      if (delivery.origin === 'parser') {
        return;
      }
      if (delivery.company_id !== hbConstants.get().COMPANY.CASER.id) {
        return;
      }
      var str, parser, xmlDoc, responseMessage;
      str = delivery.response.response;
      str = str.replace(/(\\r\\n|\\n|\\r)/gm, '');
      str = str.replace(/\\/g, '');

      parser = new DOMParser();
      xmlDoc = parser.parseFromString(str, 'text/html');
      if (!xmlDoc.getElementsByTagName('salida').length) {
        return;
      }
      responseMessage =
        (xmlDoc.getElementsByTagName('salida')[0].firstChild.nodeValue)
          .replace(/(<([^>]+)>)/ig, '').trim();
      delivery.response.response = responseMessage;
    }

    function getSettingOverridesAsString() {
      return JSON.stringify(delivery.setting_overrides, null, 4);
    }

    /**
     * Puts this delivery back in the queue.
     *
     * @return {Promise}
     */
    function repeatDelivery() {
      return askForRepeatConfirmation()
        .then(onRepeatConfirmation)
        .then(function () {
          vm.delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.QUEUED.id;
          return toastr.success('El envío ha sido encolado de nuevo');
        }, function (error) {
          return toastr.error(TranslationService.translate(error.data.error));
        });

      function onRepeatConfirmation() {
        return vm.delivery.repeat();
      }
    }

    function getErrorReasonLabelClass(attempt) {
      var classes = {};
      classes[hbConstants.get().ATTEMPT_RESULT.TERMINAL_ERROR.id] = 'label-danger';
      classes[hbConstants.get().ATTEMPT_RESULT.RETRIABLE_ERROR.id] = 'label-warning';
      classes[hbConstants.get().ATTEMPT_RESULT.SUCCESS.id] = 'label-success';
      return classes[attempt.attempt_result_id];
    }
  }

  /** @ngInject */
  function RepeatDeliveryConfirmationModalController($scope, $uibModalInstance) {
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.ok = function () {
      $uibModalInstance.close();
    };
  }
})();

(function() {
	angular
	.module('hubDeliveries')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.deliveries',
			text: 'Envíos',
			icon: 'rss',
			order: 2
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.deliveries', {
			url: '/deliveries',
			templateUrl: 'app/deliveries/deliveries.html',
			controller: 'DeliveriesController',
			controllerAs: 'vm',
		})
		.state('root.main.deliveries.byStatus', {
			url: '/status/{statusId}',
			templateUrl: 'app/deliveries/deliveries.html',
			controller: 'DeliveriesController',
			controllerAs: 'vm',
		})
		.state('root.main.deliveries.create', {
			url: '/create',
			templateUrl: 'app/deliveries/create-delivery.html',
			controller: 'CreateDeliveryController',
			controllerAs: 'vm'
		})
		.state('root.main.deliveries.detail', {
			url: '/{deliveryId}',
			templateUrl: 'app/deliveries/delivery-detail.html',
			controller: 'DeliveryDetailController',
			controllerAs: 'vm',
			resolve: {
				/* @ngInject */
				delivery: function($stateParams, Deliveries) {
					return Deliveries.one($stateParams.deliveryId)
						.get({with: 'attachments,attempts.channel.type,attempts.result,company,status,type,predecessor'});
				}
			}
		});
	}

})();

(function () {
  'use strict';

  angular
    .module('hubDeliveries')
    .controller('DeliveriesController', DeliveriesController);

  /* @ngInject */
  function DeliveriesController($scope, $stateParams, $state, toastr, hbConstants, Deliveries, UtilsService) {
    var vm = this;
    vm.deliveries = null;
    vm.hbConstants = hbConstants;
    vm.searchForm = {
      claimNumber: null
    };
    vm.ui = {
      gettingDeliveries: false
    };
    vm.next_cursor = null;
    vm.prev_cursor = null;
    vm.page = 1;
    vm.constants = hbConstants.get();
    vm.cancelDelivery = cancelDelivery;
    vm.clearSearch = clearSearch;
    vm.getDeliveries = getDeliveries;
    vm.filteringConfiguration = getFilteringConfiguration();
    vm.getDeliveryStatusBadgeClass = getDeliveryStatusBadgeClass;
    vm.search = search;
    vm.previous = previous;
    vm.next = next;
    vm.canRepeatDelivery = canRepeatDelivery;
    vm.canCancelDelivery = canCancelDelivery;
    vm.repeatDelivery = repeatDelivery;

    activate();

    function activate() {

    }

    function canRepeatDelivery(delivery) {
      return delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.FAILED.id ||
        delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.CANCELED.id;
    }

    function canCancelDelivery(delivery) {
      return delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.FAILED.id ||
        delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.AWAITING_COMPANY_RESPONSE.id;
    }

    function cancelDelivery(delivery) {
      var originalStatusId = delivery.delivery_status_id;
      delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.CANCELED.id;
      delivery.remove()
        .then(function () {
          toastr.success('El envío ha sido cancelado con éxito');
        })
        .catch(function () {
          delivery.delivery_status_id = originalStatusId;
        });
    }

    function repeatDelivery(delivery) {
      var originalStatusId = delivery.delivery_status_id;
      delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.QUEUED.id;
      delivery.repeat()
        .then(function () {
          toastr.success('El envío ha sido encolado con éxito');
        })
        .catch(function () {
          delivery.delivery_status_id = originalStatusId;
        });
    }

    /**
     * Clears the search form.
     *
     * @return {Promise}
     */
    function clearSearch() {
      vm.searchForm.claimNumber = null;
      return search();
    }

    /**
     * Fetches deliveries from the API.
     *
     * @return {Promise}
     */
    function getDeliveries(cursor) {
      var params = UtilsService.addFilterParameters({
        with: 'company,type',
        cursor: cursor
      }, vm.filteringConfiguration);
      if (vm.searchForm.claimNumber) {
        params.claim_number = vm.searchForm.claimNumber;
      }
      vm.ui.gettingDeliveries = true;
      return Deliveries.getList(params)
        .then(function (deliveries) {
          vm.deliveries = deliveries;
          vm.next_cursor = deliveries.metadata.next_cursor;
          vm.prev_cursor = deliveries.metadata.prev_cursor;
        })
        .finally(function () {
          vm.ui.gettingDeliveries = false;
        });
    }

    function getDeliveryStatusBadgeClass(statusId) {
      switch (statusId) {
        case hbConstants.get().DELIVERY_STATUS.QUEUED.id:
        default:
          return 'label-default';
        case hbConstants.get().DELIVERY_STATUS.IN_PROGRESS.id:
          return 'label-info';
        case hbConstants.get().DELIVERY_STATUS.DELIVERED.id:
          return 'label-success';
        case hbConstants.get().DELIVERY_STATUS.FAILED.id:
          return 'label-danger';
        case hbConstants.get().DELIVERY_STATUS.CANCELED.id:
          return 'label-warning';
        case hbConstants.get().DELIVERY_STATUS.AWAITING_COMPANY_RESPONSE.id:
          return 'label-primary';
      }
    }

    /**
    * Returns the configuration needed for the filtering directive.
    *
    * @returns {Array}
    */
    function getFilteringConfiguration() {
      var statusFilter = {
        'field': 'Estado del envío',
        'type': 'select',
        'values': _.sortBy(
            hbConstants.get().DELIVERY_STATUS,
            'name'
        ),
        'apiField': 'delivery_status_id',
        'displayField': 'name',
        'selectedValues': []
      };
      statusFilter.selectedValues = $stateParams.statusId ?
        [parseInt($stateParams.statusId)] : [];
      var createdDateGreaterThanFilter = {
        'field': 'Fecha mayor igual a',
        'type': 'date',
        'apiField': 'created_date_greater_than',
        'selectedValues': [
          moment().subtract(3, 'months').format('YYYY-MM-DD')
        ]
      };
      createdDateGreaterThanFilter.selectedValues = $stateParams.statusId ?
        [moment().format('YYYY-MM-DD')] : [moment().subtract(3, 'months').format('YYYY-MM-DD')];
      var createdDateLowerThanFilter = {
        'field': 'Fecha menor igual a',
        'type': 'date',
        'apiField': 'created_date_lower_than',
        'selectedValues': []
      };
      createdDateLowerThanFilter.selectedValues = $stateParams.statusId ?
        [moment().format('YYYY-MM-DD')] : [];

      var filters = [{
        'field': 'Enviado hacia',
        'type': 'select',
        'values': _.sortBy(
            hbConstants.get().COMPANY,
            'name'
        ),
        'apiField': 'company_id',
        'displayField': 'name',
        'selectedValues': []
      }, {
        'field': 'Número de siniestro',
        'type': 'text',
        'selectedValues': [],
        'apiField': 'claim_number'
      }, {
        'field': 'Tipo de envío',
        'type': 'select',
        'values': _.sortBy(
            hbConstants.get().DELIVERY_TYPE,
            'name'
        ),
        'apiField': 'delivery_type_id',
        'displayField': 'name',
        'selectedValues': []
      }];

      return _.sortBy(
          filters.concat([statusFilter, createdDateGreaterThanFilter, createdDateLowerThanFilter]),
          'field'
      );
    }

    /**
     * Performs a delivery search by claim number.
     *
     * @return {Promise}
     */
    function search() {
        vm.page = 1;
        return getDeliveries(null);
    }

    $scope.$on('filtersUpdated', function (event, data) {
      vm.next_cursor = null;
      vm.prev_cursor = null;
      vm.page = 1;
      vm.filteringConfiguration = data;
      getDeliveries(null);
    });

    $scope.$watch(function () {
      return $stateParams;
    }, function (stateParams) {
      if ($state.current.name !== 'root.main.deliveries.byStatus' ||
        ($state.current.name === 'root.main.deliveries.byStatus' && !_.isEmpty(stateParams.statusId))
      ) {
        getFilteringConfiguration();
        vm.page = 1;
        getDeliveries(null);
      }
    });

    /**
     * Go to previous page
     *
     * @returns {Promise}
     */
    function previous() {
      if (vm.prev_cursor !== null) {
          vm.page--;
        return getDeliveries(vm.prev_cursor);
      }
    }
    /**
     * Go to next page
     *
     * @returns {Promise}
     */
    function next() {
        if (vm.next_cursor !== null) {
            vm.page++;
            return getDeliveries(vm.next_cursor);
        }
    }

  }
})();

(function() {
	'use strict';

	angular
	.module('hubDeliveries')
	.controller('CreateDeliveryController', CreateDeliveryController);

	/** @ngInject */
	function CreateDeliveryController($state, toastr, hbConstants, Deliveries) {
		var vm = this;
		vm.hbConstants = hbConstants;
		vm.newDelivery = {
			company_id: null,
			delivery_type_id: null,
			claim_number: null,
			repairer_company: null,
			metadata: null,
			setting_overrides: null,
			attachments: []
		};
		vm.selectedFiles = [];
		vm.ui = {
			creatingDelivery: false
		};

		vm.createDelivery = createDelivery;
		vm.getSelectedFiles = getSelectedFiles;

		activate();

		function activate() {
		}

		function createDelivery() {
			vm.ui.creatingDelivery = true;
			vm.newDelivery.attachments = _.map(vm.selectedFiles, function (f) {
				return {filename: f.filename, content: f.base64};
			});
			Deliveries.post(vm.newDelivery)
				.then(function(delivery) {
					toastr.success('Envío creado con éxito.');
					$state.go('root.main.deliveries.detail', {deliveryId: delivery.id});
				})
				.finally(function() {
					vm.ui.creatingDelivery = false;
				});
		}

		/**
		 * Returns a string representation of the
		 * selected files.
		 *
		 * @return {String}
		 */
		function getSelectedFiles() {
			return _(vm.selectedFiles)
				.map('filename')
				.join(', ');
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hub')
	.controller('DashboardController', DashboardController);

	/** @ngInject */
	function DashboardController($http, hbConfig, hbConstants) {
		var vm = this;
		vm.stats = {};

		vm.getStats = getStats;
		vm.constants = hbConstants;

		activate();

		function activate() {
			intializeStats();
			getStats();
		}

		/**
		 * Retrieves stats from the server and
		 * populates chart data.
		 *
		 * @return {Promise}
		 */
		function getStats() {
			return $http({
				method: 'GET',
				url: hbConfig.apiEndpoint + '/stats'
			}).then(function(res) {
				vm.stats.breakdown.data = [];
				vm.stats.breakdown.labels = _.map(res.data.delivered, 'x');
				vm.stats.breakdown.data.push(_.map(res.data.delivered, 'y'));
				vm.stats.breakdown.data.push(_.map(res.data.deliveredWithWarning, 'y'));
				vm.stats.breakdown.data.push(_.map(res.data.failed, 'y'));
				vm.stats.breakdown.data.push(_.map(res.data.inProgress, 'y'));

				vm.stats.deliveredToday = _.last(res.data.delivered).y;
				vm.stats.deliveredWithWarningToday = _.last(res.data.deliveredWithWarning).y;
				vm.stats.failedToday = _.last(res.data.failed).y;
				vm.stats.inProgressToday = _.last(res.data.inProgress).y;
			});
		}

		/**
		 * Initializes the stats data structure.
		 */
		function intializeStats() {
			vm.stats = {
				deliveredToday: null,
				failedToday: null,
				breakdown: {
					colors: ['#5cb85c', '#f0ad4e', '#d9534f', '#337ab7'],
					data: null,
					labels: [],
					series: ['Entregados', 'Entregados con advertencia', 'Fallidos', 'En proceso']
				}
			};
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCustomers', []);
})();

(function() {
	angular
	.module('hubCustomers')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.customers',
			text: 'Clientes',
			icon: 'users'
		}, 'admin');
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCustomers')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.customers', {
			url: '/customers',
			templateUrl: 'app/customers/customers.html',
			controller: 'CustomersController',
			controllerAs: 'vm'
		})
		.state('root.main.customers.detail', {
			url: '/{customerId}',
			templateUrl: 'app/customers/customer-detail.html',
			controller: 'CustomerDetailController',
			controllerAs: 'vm',
			resolve: {
				/** @ngInject */
				customer: function($stateParams, Users) {
					return Users.one($stateParams.customerId).get({with: 'companies'});
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubCustomers')
	.controller('CustomersController', CustomersController);

	/** @ngInject */
	function CustomersController(hbConstants, Users) {
		var vm = this;
		vm.customers = [];

		vm.getCustomers = getCustomers;

		activate();

		function activate() {
			vm.getCustomers();
		}

		function getCustomers() {
			Users.getList({role_id: hbConstants.get().ROLE.USER.id, with: 'companies'})
				.then(function(customers) {
					vm.customers = customers;
				});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCustomers')
	.controller('CustomerDetailController', CustomerDetailController);

	/** @ngInject */
	function CustomerDetailController(toastr, hbConstants, Users, customer) {
		var vm = this;
		vm.companies = {};
		vm.customer = customer;
		vm.hbConstants = hbConstants;
		vm.newCompanyId = null;
		vm.ui = {
			savingCompanies: false
		};

		vm.saveCompanies = saveCompanies;

		activate();

		function activate() {
			var allIds = _.map(hbConstants.get().COMPANY, 'id');
			var currentIds = _.map(customer.companies, 'id');

			_.each(_.intersection(allIds, currentIds), function(val) {
				vm.companies[val] = true;
			});
			_.each(_.difference(allIds, currentIds), function(val) {
				vm.companies[val] = false;
			});
		}

		function saveCompanies() {
			var ids = _.filter(_.keys(vm.companies), function(val) {
				return vm.companies[val] === true;
			});

			vm.ui.savingCompanies = true;
			vm.customer.company_ids = ids;
			vm.customer.save({with: 'companies'})
				.then(function(customer) {
					vm.customer = customer;
					toastr.success('Cliente actualizado con éxito');
				})
				.finally(function() {
					vm.ui.savingCompanies = false;
				});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes', []);
})();
(function() {
  angular
  .module('hubChannelTypes')
  .run(runBlock);

  /** @ngInject */
  function runBlock(caMenuService) {
    caMenuService.add({
      route: 'root.main.channelTypes',
      text: 'Tipos de canal',
      icon: 'commenting'
    }, 'admin');
  }
})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.channelTypes', {
			url: '/channel_types',
			templateUrl: 'app/channel-types/channel-types.html',
			controller: 'ChannelTypesController',
			controllerAs: 'vm'
		})
		.state('root.main.channelTypes.detail', {
			url: '/{channelTypeId}',
			templateUrl: 'app/channel-types/channel-type-detail.html',
			controller: 'ChannelTypeDetailController',
			controllerAs: 'vm',
			resolve: {
				/** @ngInject */
				channelType: function($stateParams, ChannelTypes) {
					return ChannelTypes.one($stateParams.channelTypeId).get({with: 'attributes'});
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes')
	.controller('ChannelTypesController', ChannelTypesController);

	/** @ngInject */
	function ChannelTypesController(hbConstants) {
		var vm = this;
		vm.hbConstants = hbConstants;

		activate();

		////////////////

		function activate() {
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelTypes')
	.controller('ChannelTypeDetailController', ChannelTypeDetailController);

	/** @ngInject */
	function ChannelTypeDetailController(Restangular, toastr, ChannelTypeAttributes, channelType) {
		var vm = this;
		vm.channelType = channelType;
		vm.newAttribute = {};
		vm.ui = {
			addingAttribute: false
		};

		vm.addAttribute = addAttribute;
		vm.removeAttribute = removeAttribute;

		activate();

		////////////////

		function activate() {
			resetNewAttributeForm();
		}

		function addAttribute() {
			vm.ui.addingAttribute = true;
			ChannelTypeAttributes.post(vm.newAttribute)
				.then(function(attribute) {
					resetNewAttributeForm();
					vm.channelType.attributes.push(attribute);
					toastr.success('Atributo añadido con éxito.');
				})
				.finally(function() {
					vm.ui.addingAttribute = false;
				});
		}

		function removeAttribute(attribute) {
			_.remove(vm.channelType.attributes, function(val) {
				return val.id === attribute.id;
			});
			Restangular.one('channel_type_attributes', attribute.id)
				.remove()
				.then(function() {
					toastr.success('Atributo eliminado con éxito.');
				}, function() {
					vm.channelType.attributes.push(attribute);
				});
		}

		function resetNewAttributeForm() {
			vm.newAttribute = {
				channel_type_id: channelType.id,
				name: null
			};
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCompanies', []);
})();

(function () {
  'use strict';

  angular
    .module('hubCompanies')
    .controller('CompanyDetailController', CompanyDetailController);

  /** @ngInject */
  function CompanyDetailController($q, Restangular, toastr, hbConstants, Channels, Companies, company) {
    var vm = this;
    vm.channelDeliveryTypes = {};
    vm.company = company;
    vm.hbConstants = hbConstants;
    vm.newChannel = {
      channel_type_id: null,
      company_id: company.id
    };
    vm.ui = {
      addingChannel: false,
      savingDeliveryTypes: false,
      saveCompany: false,
    };

    vm.addChannel = addChannel;
    vm.getUnusedChannelTypes = getUnusedChannelTypes;
    vm.removeChannel = removeChannel;
    vm.saveChannelDeliveryTypes = saveChannelDeliveryTypes;
    vm.saveCompany = saveCompany;


    activate();

    function activate() {
      var allIds = _.map(hbConstants.get().DELIVERY_TYPE, 'id');

      // TODO: refactor this, i'm pretty sure
      // there's a more elegant, efficient way
      // of accomplishing this
      _.each(company.channels, function (channel) {
        _.each(hbConstants.get().DELIVERY_TYPE, function (deliveryType) {
          if (!vm.channelDeliveryTypes[channel.id]) {
            vm.channelDeliveryTypes[channel.id] = {};
          }
          vm.channelDeliveryTypes[channel.id][deliveryType.id] = false;
        });
        _.each(channel.delivery_types, function (deliveryType) {
          vm.channelDeliveryTypes[channel.id][deliveryType.id] = true;
        });
      });
    }

    function addChannel() {
      vm.ui.addingChannel = true;
      Channels.post(vm.newChannel, { with: 'type' })
        .then(function (channel) {
          vm.company.channels.push(channel);
          toastr.success('Canal añadido con éxito.');
        })
        .finally(function () {
          vm.ui.addingChannel = false;
        });
    }

    function getUnusedChannelTypes() {
      var allIds = _.map(hbConstants.get().CHANNEL_TYPE, 'id');
      var usedIds = _.map(vm.company.channels, 'channel_type_id');
      var availableIds = _.difference(allIds, usedIds);
      return _.filter(hbConstants.get().CHANNEL_TYPE, function (val) {
        return availableIds.indexOf(val.id) >= 0;
      });
    }

    function removeChannel(channel) {
      _.remove(vm.company.channels, function (val) {
        return val.id === channel.id;
      });
      Restangular.one('channels', channel.id)
        .remove()
        .then(function () {
          toastr.success('Canal eliminado con éxito.');
        }, function () {
          vm.company.channels.push(channel);
        });
    }

    function saveChannelDeliveryTypes() {
      var promises = [];
      vm.ui.savingChannelDeliveryTypes = true;

      _.each(vm.company.channels, function (channel) {
        var deliveryTypeIds = _.filter(_.keys(vm.channelDeliveryTypes[channel.id]), function (val) {
          return vm.channelDeliveryTypes[channel.id][val] === true;
        });
        // TODO: refactor this, don't like the way
        // I used Restangular here
        /* jshint ignore:start */
        var channel = Restangular.restangularizeElement(null, channel, 'channels');
        /* jshint ignore:end */
        channel.delivery_type_ids = deliveryTypeIds;
        promises.push(channel.put({ with: 'delivery_types,type' }));
      });

      $q.all(promises)
        .then(function () {
          toastr.success('Tipos de envío guardados con éxito.');
        })
        .finally(function () {
          vm.ui.savingChannelDeliveryTypes = false;
        });
    }

    function saveCompany() {
      var channels = vm.company.channels;
      delete (vm.company.channels);
      vm.ui.saveCompany = true;
      vm.company.save()
        .then(function (company) {
          vm.company = company;
          toastr.success('Compañia actualizado con éxito');
        })
        .finally(function () {
          vm.ui.saveCompany = false;
          vm.company.channels = channels;
        });
    }

  }
})();

(function() {
	angular
	.module('hubCompanies')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.companies',
			text: 'Compañías',
			icon: 'suitcase'
		}, 'admin');
	}
})();

(function() {
	'use strict';

	angular
	.module('hubCompanies')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.companies', {
			url: '/companies',
			templateUrl: 'app/companies/companies.html',
			controller: 'CompaniesController',
			controllerAs: 'vm'
		})
		.state('root.main.companies.detail', {
			url: '/{companyId}',
			templateUrl: 'app/companies/company-detail.html',
			controller: 'CompanyDetailController',
			controllerAs: 'vm',
			resolve: {
				/** @ngInject */
				company: function($stateParams, Companies) {
					return Companies.one($stateParams.companyId).get({with: 'channels.delivery_types,channels.type'});
				}
			}
		});
	}

})();

(function() {
	'use strict';

	angular
	.module('hubCompanies')
	.controller('CompaniesController', CompaniesController);

	/** @ngInject */
	function CompaniesController(Companies) {
		var vm = this;
		vm.companies = [];

		vm.getCompanies = getCompanies;

		activate();

		function activate() {
			vm.getCompanies();
		}

		function getCompanies() {
			Companies.getList({with: 'channels,channels.type'})
				.then(function(companies) {
					vm.companies = companies;
				});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelSettings', []);
})();

(function() {
	angular
	.module('hubChannelSettings')
	.run(runBlock);

	/** @ngInject */
	function runBlock(caMenuService) {
		caMenuService.add({
			route: 'root.main.channelSettings',
			text: 'Canales',
			icon: 'code-fork'
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelSettings')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root.main.channelSettings', {
			url: '/channel-settings',
			templateUrl: 'app/channel-settings/channel-settings.html',
			controller: 'ChannelSettingsController',
			controllerAs: 'vm'
		});
	}

})();

(function () {
	'use strict';

	angular
		.module('hubChannelSettings')
		.controller('ChannelSettingsController', ChannelSettingsController);

	/** @ngInject */
	function ChannelSettingsController (
		$q,
		$uibModal,
		toastr,
		Restangular,
		hbConstants,
		ChannelSettings,
		Channels,
		Companies
	) {
		var vm = this;
		vm.activeCompanyId = null;
		vm.channels = [];
		vm.companies = [];
		vm.editedSettings = [];
		vm.hbConstants = hbConstants;
		vm.settings = [];
		vm.ui = {
			savingSettings: false
		};

		vm.addChannelSetting = addChannelSetting;
		vm.createChannelSetting = createChannelSetting;
		vm.editChannelSettingAttributes = editChannelSettingAttributes;
		vm.getChannelSettings = getChannelSettings;
		vm.getChannels = getChannels;
		vm.getUnusedChannels = getUnusedChannels;
		vm.lowerPriority = lowerPriority;
		vm.openChannelSettingAttributesDialog = openChannelSettingAttributesDialog;
		vm.raisePriority = raisePriority;
		vm.removeSetting = removeSetting;
		vm.saveChannelSettings = saveChannelSettings;
		vm.setActiveCompany = setActiveCompany;

		activate();

		function activate () {
			// tmp, should only see companies assigned to user
			vm.companies = hbConstants.asArray('COMPANY');
			setActiveCompany(vm.companies[0].id);

			vm.getChannelSettings();
			vm.getChannels();
		}

		function addChannelSetting (channel) {
			if (channel.type.attributes.length) {
				openChannelSettingAttributesDialog(channel)
					.result
					.then(function (attributes) {
						createChannelSetting(channel, attributes);
					});
			} else {
				createChannelSetting(channel, {});
			}
		}

		function createChannelSetting (channel, attributes) {
			var newSetting = {
				channel_id: channel.id,
				attributes: attributes
			};
			ChannelSettings.post(newSetting, { with: 'channel.status,channel.type.attributes' })
				.then(function (setting) {
					vm.settings.push(setting);
					updateEditedSettings();
					toastr.success('Canal añadido con éxito.');
				})
				.finally(function () {

				});
		}

		function editChannelSettingAttributes (setting) {
			console.log(setting);
			openChannelSettingAttributesDialog(setting.channel, setting.attributes);
		}

		function getChannelSettings () {
			ChannelSettings.getList({ with: 'channel.status,channel.type.attributes' })
				.then(function (settings) {
					vm.settings = settings;
					updateEditedSettings();
				});
		}

		function getChannels () {
			Channels.getList({ with: 'status,type.attributes' })
				.then(function (channels) {
					vm.channels = channels;
				});
		}

		function getUnusedChannels () {
			var usedIds = _.map(vm.editedSettings, 'channel_id');
			return _.filter(vm.channels, function (val) {
				return val.company_id === vm.activeCompanyId && usedIds.indexOf(val.id) < 0;
			});
		}

		function lowerPriority (setting) {
			if (vm.editedSettings.length < 2) {
				return;
			}

			var idx = _.findIndex(vm.editedSettings, 'id', setting.id);
			if (idx === vm.editedSettings.length - 1) {
				return;
			}

			var from;
			var to;
			if (idx === vm.editedSettings.length - 2) {
				var maxPriority = vm.editedSettings[idx + 1].priority;
				vm.editedSettings[idx + 1].priority = setting.priority;
				setting.priority = maxPriority;
			} else {
				from = vm.editedSettings[idx + 1].priority;
				to = vm.editedSettings[idx + 2].priority;
				setting.priority = (to - from) / 2;
			}

			sortSettings();
		}

		function openChannelSettingAttributesDialog (channel, attributes) {
			return $uibModal.open({
				controller: 'AttributesModalController',
				controllerAs: 'vm',
				resolve: {
					channel: channel,
					attributes: function () { return attributes; }
				},
				templateUrl: 'app/channel-settings/attributes-modal.html',
			});
		}

		function raisePriority (setting) {
			if (vm.editedSettings.length < 2) {
				return;
			}

			var idx = _.findIndex(vm.editedSettings, 'id', setting.id);
			if (idx === 0) {
				return;
			}

			var from;
			var to;
			if (idx === 1) {
				from = 0;
				to = vm.editedSettings[idx - 1].priority;
			} else {
				from = vm.editedSettings[idx - 2].priority;
				to = vm.editedSettings[idx - 1].priority;
			}

			setting.priority = (to - from) / 2;
			sortSettings();
		}

		function removeSetting (setting) {
			_.remove(vm.settings, function (val) {
				return val.id === setting.id;
			});
			updateEditedSettings();

			Restangular.one('channel_settings', setting.id)
				.remove()
				.then(function () {
					toastr.success('Canal eliminado con éxito.');
				}, function () {
					/* jshint ignore:start */
					vm.company.channels.push(channel);
					/* jshint ignore:end */
					updateEditedSettings();
				});
		}

		function saveChannelSettings () {
			var promises = [];
			_.each(vm.editedSettings, function (val) {
				promises.push(val.save());
			});

			vm.ui.savingSettings = true;
			$q.all(promises)
				.then(function () {
					toastr.success('Canales guardados con éxito.');
				})
				.finally(function () {
					vm.ui.savingSettings = false;
				});
		}

		function setActiveCompany (companyId) {
			vm.activeCompanyId = companyId;
			updateEditedSettings();
		}

		function sortSettings () {
			vm.editedSettings = _.sortBy(vm.editedSettings, 'priority');
		}

		function updateEditedSettings () {
			vm.editedSettings = _.filter(vm.settings, function (val) {
				return val.channel.company_id === vm.activeCompanyId;
			});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubChannelSettings')
	.controller('AttributesModalController', AttributesModalController);

	/** @ngInject */
	function AttributesModalController($uibModalInstance, channel, attributes) {
		var vm = this;
		vm.attributeValues = attributes;
		vm.channel = channel;

		vm.cancel = cancel;
		vm.ok = ok;

		activate();

		////////////////

		function activate() {
		}

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}

		function ok() {
			$uibModalInstance.close(vm.attributeValues);
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubAuth', ['hubApi']);
})();

(function() {
    'use strict';

    angular
    .module('hubAuth')
    .factory('hbSession', HbSession);

    function HbSession(CurrentUser, OAuthManager) {
        var _user = null;

        var service =  {
            promise: promise,
            get: get,
            clear: clear
        };

        return service;

        function promise() {
          return CurrentUser.get().then(function(data) {
            _user = data;
          });
        }

        function get() {
            return _user;
        }

        function clear() {
            _user = null;
        }
    }
})();

(function() {
	'use strict';

	angular
	.module('hubAuth')
	.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($scope, $rootScope, $state, toastr, OAuthManager) {
		var vm = this;

		vm.loginForm = {
			username: null,
			password: null
		};
		vm.ui = {
			loggingIn: false
		};

		vm.login = login;

		activate();

		function activate() {
		}

		function login() {
			vm.ui.loggingIn = true;
			OAuthManager.login(vm.loginForm.username, vm.loginForm.password)
			.then(function() {
				$state.go('root.main.dashboard');
				toastr.success('¡Bienvenido!');
			})
			.finally(function() {
				vm.ui.loggingIn = false;
			});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('hubAuth')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
		.state('root.login', {
			url: '/login',
			templateUrl: 'app/auth/login.html',
			controller: 'LoginController',
			controllerAs: 'vm'
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('hubApi', ['restangular'])
	.config(HubConfig)
	.factory('Channels', Channels)
	.factory('ChannelSettings', ChannelSettings)
	.factory('ChannelTypeAttributes', ChannelTypeAttributes)
	.factory('ChannelTypes', ChannelTypes)
	.factory('Companies', Companies)
	.factory('Constants', Constants)
	.factory('Deliveries', Deliveries)
	.factory('CurrentUser', CurrentUser)
	.factory('Users', Users)
	.factory('RevokeToken', RevokeToken);

	/** @ngInject */
	function HubConfig(RestangularProvider) {
		RestangularProvider.extendModel('deliveries', function (delivery) {
			delivery.addRestangularMethod('repeat', 'post', 'repeat');
			return delivery;
		});
	}

	/** @ngInject */
	function Channels(Restangular) {
		return Restangular.service('channels');
	}

	/** @ngInject */
	function ChannelSettings(Restangular) {
		return Restangular.service('channel_settings');
	}

	/** @ngInject */
	function ChannelTypeAttributes(Restangular) {
		return Restangular.service('channel_type_attributes');
	}

	/** @ngInject */
	function ChannelTypes(Restangular) {
		return Restangular.service('channel_types');
	}

	/** @ngInject */
	function Companies(Restangular) {
		return Restangular.service('companies');
	}

	/** @ngInject */
	function Constants(Restangular) {
		return Restangular.service('constants');
	}

	/** @ngInject */
	function Deliveries(Restangular) {
		return Restangular.service('deliveries');
	}

	/** @ngInject */
	function CurrentUser(Restangular) {
	  return Restangular.one('/users/me').withHttpConfig({cache: true});
	}

	/** @ngInject */
	function Users(Restangular) {
		return Restangular.service('users');
	}


    /** @ngInject */
    function RevokeToken(Restangular) {
        return Restangular.service('/users/revoke_token');
    }
})();

(function() {
	'use strict';

	angular
	.module('hubApi')
	.factory('hbConstants', HbConstants);

	/** @ngInject */
	function HbConstants($log, $q, Restangular) {
		var vals = {};

		var service = {
			promise: promise,
			get: get,
			byId: byId,
			asArray: asArray
		};

		return service;

		function promise() {
			return Restangular.all('constants')
				.customGET('')
				.then(function(data) {
					vals = data.plain();
					angular.forEach(data.plain(), function(v, k) {
						angular.forEach(vals[k], function(value, key) {
							value.key = key.toLowerCase();
						});
						// vals[k].byId = function(id) {
						// 	return findById(v, parseInt(id));
						// }
					});
				});
		}

		function get() {
			return vals;
		}

		function byId(key, id) {
			if (! vals.hasOwnProperty(key)) {
				$log.error('No key found: ' + key);
				return null;
			}

			for (var k in vals[key]) {
				if (vals[key][k].id === id) {
					return vals[key][k];
				}
			}

			$log.error('ID ' + id + ' not found for key ' + key);
			return null;
		}

		function asArray(key) {
			if (! vals.hasOwnProperty(key)) {
				$log.error('No key found: ' + key);
				return null;
			}

			return _.map(vals[key], function(v) {return v;});
		}
	}
})();


'use strict';

angular.module('hub')

.factory('UtilsService', UtilsService);

function UtilsService(
  $state,
  FiltersService
) {
  var vals = {};
  var service = {
    addFilterParameters: addFilterParameters
  };

  return service;

  /**
   * Adds the appropiate parameters to the parameters array
   * from the filtering configuration.
   * @param  {array} parameters
   * @param  {array} filteringConfiguration
   * @return {array}
   */
  function addFilterParameters(parameters, filteringConfiguration) {
    var result = FiltersService.getFiltersFromCache($state.current.name);
    if (result) {
      filteringConfiguration = result;
    }
    filteringConfiguration.forEach(function (configEntry) {
      if (configEntry.selectedValues.length > 0) {
        var paramName;
        if (configEntry.apiField === undefined) {
          paramName = configEntry.field ;
        } else {
          paramName = configEntry.apiField ;
        }
        if (configEntry.type === 'date') {
          configEntry.selectedValues = configEntry.selectedValues.map(function (date) {
            return moment(date).format('YYYY-MM-DD');
          });
        }
        parameters[paramName] = configEntry.selectedValues.join();

      }
    });
    return parameters;
  }
}

(function () {
  'use strict';

  angular
    .module('hub')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, toastr, OAuthManager, caMenuService) {
    // globally handle error events thrown by our http interceptor
    $rootScope.$on('httpError', function (event, httpResponse) {
      var msg = null;
      if (typeof (httpResponse.data) !== 'undefined' && httpResponse.data !== null) {
        msg = httpResponse.data.description;
        if (httpResponse.data.validation_errors) {
          msg += ': ' + httpResponse.data.validation_errors[0];
        }
      } else {
        msg = 'Se ha producido un error desconocido';
      }
      if (httpResponse.status === 401) {
        msg = 'Las credenciales no coinciden con nuestros registros';
      }

      toastr.error(msg);

      if (httpResponse.status === 401) {
        $state.go('root.login');
      }
    });

    /*
     * State change handlers:
     *  - if already logged in, prevent the user from
     *    going to the login page.
     *  - if not logged in, keep the user within the
     *    login page.
     */
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      if (toState.name === 'root.login' && OAuthManager.isLoggedIn()) {
        event.preventDefault();
        if (!fromState.name || fromState.name.length <= 0) {
          $state.go('root.main.dashboard');
        }
      } else if (toState.name !== 'root.login' && !OAuthManager.isLoggedIn()) {
        event.preventDefault();
        $state.go('root.login');
      }
    });

    caMenuService.add({
      route: 'root.main.dashboard',
      text: 'Dashboard',
      icon: 'dashboard',
      order: 1
    });
  }

})();

(function() {
	'use strict';

	angular
	.module('hub')
	.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider) {
		$stateProvider
		.state('root', {
			abstract: true,
			template: '<ui-view/>'
		})
		.state('root.main', {
			abstract: true,
			templateUrl: 'app/main/main.html',
			controller: 'MainController',
			controllerAs: 'vm',
			resolve: {
				constants: function(hbConstants) {
					return hbConstants.promise();
				},
				session: function(hbSession) {
					return hbSession.promise();
				}
			}
		})
		.state('root.main.dashboard', {
			url: '/',
			templateUrl: 'app/dashboard/dashboard.html',
			controller: 'DashboardController',
			controllerAs: 'vm'
		});

		$urlRouterProvider.otherwise('/');
	}

})();

/* moment:false */
(function() {
    'use strict';

    angular
        .module('hub')
        .constant('moment', moment)
        .constant('hbConfig', {});
})();

(function () {
	'use strict';

	angular
		.module('hub')
		.config(config);

	/** @ngInject */
	function config (
		$logProvider,
		$stateProvider,
		$urlRouterProvider,
		$httpProvider,
		toastrConfig,
		RestangularProvider,
		OAuthManagerProvider,
		OAuthInterceptorProvider,
		hbConfig
	) {
		// Enable log
		$logProvider.debugEnabled(true);

		// Set options third-party lib
		toastrConfig.allowHtml = true;
		toastrConfig.timeOut = 3000;
		toastrConfig.positionClass = 'toast-top-right';
		toastrConfig.preventOpenDuplicates = true;
		toastrConfig.progressBar = true;

		// restanguar config
		RestangularProvider.setBaseUrl(hbConfig.apiEndpoint);
		RestangularProvider.addResponseInterceptor(parsePaginatedResponses);

		function parsePaginatedResponses (data, operation, what, url, response, deferred) {
			/* jshint ignore:start */
			var response = data;
			/* jshint ignore:end */
			if (operation === 'getList' &&
				Object.prototype.toString.call(data) === '[object Object]') {
				response = data.data;
				response.metadata = _.omit(data, 'data');
			}
			return response;
		}

		$httpProvider.interceptors.push(function ($q, $rootScope, $window, $location, OAuthManagerStorage) {
			return {
				request: function (config) {
					return config;
				},
				responseError: function (rejection) {
					if (rejection.status === 401) {
						if ($location.path().indexOf('login') < 0) {
							if (OAuthManagerStorage.cleanUrl(rejection.config.url) === hbConfig.apiEndpoint) {
								$location.path('login');
							}
						}
					}

					$rootScope.$broadcast('httpError', rejection);
					return $q.reject(rejection);
				}
			};
		});

		// Oauth interceptor
		OAuthInterceptorProvider.registerHost(hbConfig.apiEndpoint);

		$httpProvider.interceptors.push(function (OAuthInterceptor) {
			return OAuthInterceptor;
		});

		OAuthManagerProvider.setApiEndpoint(hbConfig.apiEndpoint);
		OAuthManagerProvider.setClientId(hbConfig.clientId);
		OAuthManagerProvider.setClientSecret(hbConfig.clientSecret);
		OAuthManagerProvider.setGrantType(hbConfig.grantType);
		OAuthManagerProvider.setScope(hbConfig.scope);
	}
})();

(function() {
	'use strict';

	angular
		.module('hub')
		.factory('hbDeliveryUtils', hbDeliveryUtils);

	hbDeliveryUtils.$inject = ['hbConstants', 'toastr', '$q', '$uibModal'];

	/** @ngInject */
	function hbDeliveryUtils(hbConstants, toastr, $q, $uibModal) {
		var service = {
			canRepeat: canRepeat,
			repeat: repeat,
			canCanceled: canCanceled,
			canceled: canceled
		};

		return service;

		////////////////

		/**
		 * If the delivery has already been delivered,
		 * shows a confirmation modal before repeating
		 * the delivery and returns a promise with the
		 * modal result.
		 *
		 * Otherwise this function returns a promise
		 * which will be immediately resolved.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function askForRepeatConfirmation(delivery) {
			// only ask for confirmation if delivery has already been delivered
			if (delivery.delivery_status_id === hbConstants.get().DELIVERY_STATUS.DELIVERED.id) {
				return $uibModal.open({
					controller: 'RepeatDeliveryConfirmationModalController',
					templateUrl: 'app/deliveries/repeat-delivery-confirmation-modal.html'
				}).result;
			}

			// otherwise just simulate the modal
			var deferred = $q.defer();
			deferred.resolve('ok');
			return deferred.promise;
		}

		/**
		 * Returns whether the current delivery can
		 * be repeated.
		 *
		 * @param {Object} delivery
		 * @return {Boolean}
		 */
		function canRepeat(delivery) {
			var allowedStatus = [
				hbConstants.get().DELIVERY_STATUS.FAILED.id,
				hbConstants.get().DELIVERY_STATUS.DELIVERED.id
			];
			return allowedStatus.indexOf(delivery.delivery_status_id) >= 0;
		}

		/**
		 * Puts this delivery back in the queue.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function repeat(delivery) {
			return askForRepeatConfirmation(delivery).then(onRepeatConfirmation)
				.then(onRepeatSuccess);

			function onRepeatConfirmation() {
				return delivery.repeat();
			}

			function onRepeatSuccess() {
				delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.QUEUED.id;
				toastr.success('El envío ha sido encolado de nuevo');
			}
		}

		/**
		 * Returns whether the current delivery can
		 * be canceled.
		 *
		 * @param {Object} delivery
		 * @return {Boolean}
		 */
		function canCanceled(delivery) {
			var allowedStatus = [
				hbConstants.get().DELIVERY_STATUS.QUEUED.id,
				hbConstants.get().DELIVERY_STATUS.IN_PROGRESS.id,
				hbConstants.get().DELIVERY_STATUS.FAILED.id
			];
			return allowedStatus.indexOf(delivery.delivery_status_id) >= 0;
		}

		/**
		 * Cancels the current delivery.
		 *
		 * @param {Object} delivery
		 * @return {Promise}
		 */
		function canceled(delivery) {
			var originalStatusId = delivery.delivery_status_id;

			delivery.remove()
				.then(function() {
					delivery.delivery_status_id = hbConstants.get().DELIVERY_STATUS.CANCELED.id;
					toastr.success('El envío ha sido cancelado con éxito');
				})
				.catch(function() {
					delivery.delivery_status_id = originalStatusId;
				});
		}
	}
})();


angular.module("hub").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/login.html","<div class=\"content login-page\"><div class=\"col-md-4 col-md-offset-4\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Panel de gestión de Veryeasy Hub</h3></div><div class=\"panel-body\"><p>Bienvenido. Para continuar, es necesario que inicie sesión.</p><form name=\"loginForm\" class=\"form-horizontal\" ng-submit=\"vm.login()\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">Usuario</label><div class=\"col-md-9\"><input type=\"text\" name=\"username\" class=\"form-control\" ng-model=\"vm.loginForm.username\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">Contraseña</label><div class=\"col-md-9\"><input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.loginForm.password\"></div></div><div class=\"form-group\"><div class=\"col-md-9 col-md-offset-3\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.loggingIn\"><span ng-if=\"vm.ui.loggingIn\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i> Autenticando...</span> <span ng-if=\"! vm.ui.loggingIn\">Iniciar sesión</span></button></div></div></form></div></div></div></div>");
$templateCache.put("app/channel-settings/attributes-modal.html","<form class=\"form-horizontal\" name=\"channelSettingAttributesForm\" ng-submit=\"vm.ok()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Configuración de atributos</h3></div><div class=\"modal-body\"><p>Los canales de tipo <strong>{{ ::vm.channel.type.name }}</strong> necesitan que configure los siguientes atributos para operar correctamente. Podrá editar los valores más adelante.</p><div class=\"form-group\" ng-repeat=\"attribute in ::vm.channel.type.attributes\"><label class=\"col-md-4 control-label\" for=\"\">{{ ::attribute.name }}</label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" required=\"\" ng-model=\"vm.attributeValues[attribute.name]\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"channelSettingAttributesForm.$invalid\">Añadir canal</button> <button class=\"btn btn-link\" type=\"button\" ng-click=\"vm.cancel()\">Cancelar</button></div></form>");
$templateCache.put("app/channel-settings/channel-settings.html","<h1 class=\"page-header\">Canales</h1><ul class=\"nav nav-pills\"><li ng-repeat=\"company in ::vm.companies\" ng-click=\"vm.setActiveCompany(company.id)\" ng-class=\"{\'active\': vm.activeCompanyId === company.id}\"><a href=\"\">{{ company.name }}</a></li></ul><h3>Canales existentes</h3><p>Haga click en las flechas para modificar el orden de prioridad de los canales. Haga click en la casilla para activar y desactivar un canal concreto.</p><form ng-if=\"vm.editedSettings.length > 0\"><div class=\"list-group\"><div class=\"list-group-item\" ng-repeat=\"setting in vm.editedSettings\" ng-class=\"{\'hb-channel-disabled\': setting.enabled == false}\"><p class=\"list-group-item-text\"><span class=\"fa-fw pull-left\"><input type=\"checkbox\" ng-model=\"setting.enabled\"></span> <span><hb-channel-status-icon status=\"setting.channel.status.id\"></hb-channel-status-icon>{{ ::setting.channel.type.name }}</span> <span class=\"pull-right\"><a href=\"\" uib-tooltip=\"Aumentar prioridad\" tooltip-append-to-body=\"true\" ng-click=\"vm.raisePriority(setting)\"><i class=\"fa fa-fw fa-single fa-arrow-up\"></i></a> <a href=\"\" uib-tooltip=\"Reducir prioridad\" tooltip-append-to-body=\"true\" ng-click=\"vm.lowerPriority(setting)\"><i class=\"fa fa-fw fa-single fa-arrow-down\"></i></a> <a href=\"\" uib-tooltip=\"Editar atributos\" tooltip-append-to-body=\"true\" ng-click=\"vm.editChannelSettingAttributes(setting)\"><i class=\"fa fa-fw fa-single fa-edit\"></i></a> <a href=\"\" uib-tooltip=\"Eliminar canal\" tooltip-append-to-body=\"true\" ng-click=\"vm.removeSetting(setting)\"><i class=\"fa fa-fw fa-single fa-trash\"></i></a></span></p></div></div><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.savingSettings\" ng-click=\"vm.saveChannelSettings()\"><span ng-if=\"vm.ui.savingSettings\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando cambios...</span> <span ng-if=\"! vm.ui.savingSettings\">Guardar cambios</span></button></div></form><div class=\"alert alert-info\" ng-if=\"vm.editedSettings.length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No está utilizando ningún canal en {{ vm.hbConstants.byId(\'COMPANY\', vm.activeCompanyId).name }}. Configure uno para poder enviar comunicaciones a esta compañía.</p></div><h3>Añadir un nuevo canal</h3><p>Estos son los canales disponibles para {{ vm.hbConstants.byId(\'COMPANY\', vm.activeCompanyId).name }} pero que usted no está utilizando. Si desea añadir alguno, haga click en <i class=\"fa fa-plus\"></i>.</p><div class=\"list-group\"><div class=\"list-group-item\" ng-repeat=\"channel in vm.getUnusedChannels()\"><p class=\"list-group-item-text\"><span><hb-channel-status-icon status=\"channel.status.id\"></hb-channel-status-icon>{{ ::channel.type.name }}</span> <span class=\"pull-right\"><a href=\"\" uib-tooltip=\"Añadir canal\" tooltip-append-to-body=\"true\" ng-click=\"vm.addChannelSetting(channel)\"><i class=\"fa fa-fw fa-plus\"></i></a></span></p></div></div><div class=\"alert alert-info\" ng-if=\"vm.getUnusedChannels().length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Ya ha configurado todos los canales disponibles para {{ vm.hbConstants.byId(\'COMPANY\', vm.activeCompanyId).name }}.</p></div>");
$templateCache.put("app/channel-types/channel-type-detail.html","<h1 class=\"page-header\">{{ ::vm.channelType.name }}</h1><uib-tabset><uib-tab heading=\"Atributos\"><h3>Atributos</h3><p>Defina a continuación los atributos utilizados para configurar este tipo de canal.</p><form class=\"form form-horizontal\" name=\"newAttributeForm\" ng-submit=\"vm.addAttribute()\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">Nombre</label><div class=\"col-md-5\"><input class=\"form-control\" type=\"text\" name=\"name\" required=\"\" ng-disabled=\"vm.ui.addingAttribute\" ng-model=\"vm.newAttribute.name\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.addingAttribute || newAttributeForm.$invalid\"><span ng-if=\"vm.ui.addingAttribute\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Añadiendo...</span> <span ng-if=\"! vm.ui.addingAttribute\">Añadir atributo</span></button></div></div></form><table class=\"table table-striped\" ng-if=\"vm.channelType.attributes.length > 0\"><thead><tr><th>Nombre</th><th></th></tr></thead><tbody><tr ng-repeat=\"attribute in vm.channelType.attributes\"><td>{{ ::attribute.name }}</td><td><a href=\"\" ng-click=\"vm.removeAttribute(attribute)\"><i class=\"fa fa-fw fa-trash\"></i>Eliminar</a></td><td></td></tr></tbody></table><div class=\"alert alert-info\" ng-if=\"vm.channelType.attributes.length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Este tipo de canal no tiene ningún atributo definido.</p></div></uib-tab></uib-tabset>");
$templateCache.put("app/channel-types/channel-types.html","<div ui-view=\"\"><h1 class=\"page-header\">Tipos de canal</h1><table class=\"table\"><thead><tr><th>Tipo</th></tr></thead><tbody><tr ng-repeat=\"type in ::vm.hbConstants.get().CHANNEL_TYPE\"><td><a ui-sref=\"root.main.channelTypes.detail({channelTypeId: type.id})\">{{ ::type.name }}</a></td></tr></tbody></table></div>");
$templateCache.put("app/companies/companies.html","<div ui-view=\"\"><h1 class=\"page-header\">Compañías</h1><table class=\"table table-striped\"><thead><tr><th>Compañía</th></tr></thead><tbody><tr ng-repeat=\"company in vm.companies\"><td><a ui-sref=\"root.main.companies.detail({companyId: company.id})\">{{ ::company.name }}</a></td></tr></tbody></table></div>");
$templateCache.put("app/companies/company-detail.html","<h1 class=\"page-header\">{{ vm.company.name }}</h1><div class=\"row\"><div class=\"col-md-12\"><form class=\"form-horizontal\" ng-submit=\"vm.saveCompany()\"><div class=\"form-group text-center\"><div class=\"col-md-12\"><div class=\"form-check\"><label class=\"form-check-label\">{{ \'send_communication\' | translate }}</label> <input type=\"checkbox\" ng-model=\"vm.company.send_communication\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"form-check-input\"></div></div></div><div class=\"form-group text-center\"><div class=\"col-md-12\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.saveCompany\"><span ng-if=\"vm.ui.saveCompany\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando...</span> <span ng-if=\"!vm.ui.saveCompany\">Guardar</span></button></div></div></form></div><div class=\"col-md-12\"><uib-tabset><uib-tab heading=\"Canales\"><h3>Canales disponibles</h3><p>Seleccione a continuación qué canales pueden usarse para enviar comunicaciones a esta compañía.</p><form class=\"form form-horizontal\" name=\"newChannelForm\" ng-if=\"vm.getUnusedChannelTypes().length > 0\" ng-submit=\"vm.addChannel()\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">Tipo de canal</label><div class=\"col-md-5\"><select class=\"form-control\" required=\"\" ng-options=\"type.id as type.name for type in vm.getUnusedChannelTypes() track by type.id\" ng-model=\"vm.newChannel.channel_type_id\"><option value=\"\">Seleccione un tipo de canal...</option></select></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.addingChannel || newChannelForm.$invalid\"><span ng-if=\"vm.ui.addingChannel\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Creando...</span> <span ng-if=\"! vm.ui.addingChannel\">Crear canal</span></button></div></div></form><div class=\"alert alert-info\" ng-if=\"vm.getUnusedChannelTypes().length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Esta compañía ya hace uso de todos los tipos de canales disponibles.</p></div><table class=\"table table-striped\" ng-if=\"vm.company.channels.length > 0\"><thead><tr><th>Tipo de canal</th><th></th></tr></thead><tbody><tr ng-repeat=\"channel in vm.company.channels\"><td>{{ ::channel.type.name }}</td><td><a href=\"\" ng-click=\"vm.removeChannel(channel)\"><i class=\"fa fa-fw fa-trash\"></i>Eliminar</a></td></tr></tbody></table><div class=\"alert alert-warning\" ng-if=\"vm.company.channels.length === 0\"><p><i class=\"fa fa-fw fa-exclamation-triangle\"></i>Esta compañía no tiene ningún canal.</p></div></uib-tab><uib-tab heading=\"Tipos de envío\"><h3>Tipos de envío</h3><p>Seleccione qué tipos de envío permite esta compañía para cada canal.</p><table class=\"table table-striped\"><thead><tr><th></th><th ng-repeat=\"channel in vm.company.channels\">{{ channel.type.name }}</th></tr></thead><tbody><tr ng-repeat=\"type in ::vm.hbConstants.get().DELIVERY_TYPE\"><td>{{ ::type.name }}</td><td ng-repeat=\"channel in vm.company.channels\"><input type=\"checkbox\" ng-model=\"vm.channelDeliveryTypes[channel.id][type.id]\"></td></tr></tbody></table></uib-tab></uib-tabset></div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveChannelDeliveryTypes()\" ng-disabled=\"vm.ui.savingChannelDeliveryTypes\"><span ng-if=\"vm.ui.savingChannelDeliveryTypes\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando...</span> <span ng-if=\"! vm.ui.savingChannelDeliveryTypes\">Guardar</span></button></div>");
$templateCache.put("app/customers/customer-detail.html","<h1 class=\"page-header\">{{ vm.customer.username }}</h1><div class=\"row\"><div class=\"col-md-12\"><h3>Compañías asignadas</h3><p>Seleccione con qué compañías puede comunicarse este cliente.</p><form class=\"form-horizontal\" ng-submit=\"vm.saveCompanies()\"><div class=\"form-group\" ng-repeat=\"company in ::vm.hbConstants.get().COMPANY\"><div class=\"col-md-offset-3 col-md-5\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"vm.companies[company.id]\"> {{ ::company.name }}</label></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vm.ui.savingCompanies\"><span ng-if=\"vm.ui.savingCompanies\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Guardando...</span> <span ng-if=\"! vm.ui.savingCompanies\">Guardar</span></button></div></div></form></div></div>");
$templateCache.put("app/customers/customers.html","<div ui-view=\"\"><h1 class=\"page-header\">Clientes</h1><table class=\"table table-striped\"><thead><tr><th>Cliente</th><th>Fecha de creación</th></tr></thead><tbody><tr ng-repeat=\"customer in vm.customers\"><td><a ui-sref=\"root.main.customers.detail({customerId: customer.id})\">{{ ::customer.username }}</a></td><td>{{ ::customer.created_at | amDateFormat:\'DD/MM/YY HH:mm:ss\' }}</td></tr></tbody></table></div>");
$templateCache.put("app/dashboard/dashboard.html","<h1 class=\"page-header\">Dashboard</h1><div class=\"row\"><div class=\"col-md-3\"><a href=\"/#!/deliveries/status/{{vm.constants.get().DELIVERY_STATUS.DELIVERED.id}}\"><div class=\"panel panel-green\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"fa fa-check fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><div class=\"hb-huge\">{{ vm.stats.deliveredToday || \'-\' }}</div><div>envíos exitosos hoy</div></div></div></div></div></a></div><div class=\"col-md-3\"><a href=\"/#!/deliveries/status/{{vm.constants.get().DELIVERY_STATUS.DELIVERED_WITH_WARNING.id}}\"><div class=\"panel panel-yellow\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"fa fa-warning fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><div class=\"hb-huge\">{{ vm.stats.deliveredWithWarningToday || \'-\' }}</div><div>con advertencia hoy</div></div></div></div></div></a></div><div class=\"col-md-3\"><a href=\"/#!/deliveries/status/{{vm.constants.get().DELIVERY_STATUS.IN_PROGRESS.id}}\"><div class=\"panel panel-blue\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"fa fa-spinner fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><div class=\"hb-huge\">{{ vm.stats.inProgressToday || \'-\' }}</div><div>en curso +10 min hoy</div></div></div></div></div></a></div><div class=\"col-md-3\"><a href=\"/#!/deliveries/status/{{vm.constants.get().DELIVERY_STATUS.FAILED.id}}\"><div class=\"panel panel-red\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"fa fa-exclamation-circle fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><div class=\"hb-huge\">{{ vm.stats.failedToday || \'-\' }}</div><div>envíos fallidos hoy</div></div></div></div></div></a></div></div><h3>Entregados vs. fallidos vs. en proceso (últimos 14 días)</h3><div class=\"alert alert-info\" ng-if=\"!vm.stats.breakdown.data\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No hay datos que mostrar.</p></div><canvas id=\"chart\" class=\"chart chart-line\" chart-data=\"vm.stats.breakdown.data\" chart-labels=\"vm.stats.breakdown.labels\" chart-series=\"vm.stats.breakdown.series\" chart-colours=\"vm.stats.breakdown.colors\"></canvas>");
$templateCache.put("app/deliveries/create-delivery.html","<h1 class=\"page-header\">Nuevo envío</h1><form class=\"form-horizontal\" name=\"newDeliveryForm\" ng-submit=\"vm.createDelivery()\"><div class=\"form-group\"><label for=\"companyId\" class=\"col-md-3 control-label\">Compañía</label><div class=\"col-md-5\"><select id=\"companyId\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.company_id\" ng-options=\"company.id as company.name for company in vm.hbConstants.get().COMPANY track by company.id\"><option value=\"\">Seleccione una compañía...</option></select></div></div><div class=\"form-group\"><label for=\"deliveryTypeId\" class=\"col-md-3 control-label\">Tipo de envío</label><div class=\"col-md-5\"><select id=\"deliveryTypeId\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.delivery_type_id\" ng-options=\"type.id as type.name for type in vm.hbConstants.get().DELIVERY_TYPE track by type.id\"><option value=\"\">Seleccione un tipo de envío...</option></select></div></div><div class=\"form-group\"><label for=\"claimNumber\" class=\"col-md-3 control-label\">Número de siniestro</label><div class=\"col-md-5\"><input id=\"claimNumber\" type=\"text\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.claim_number\"></div></div><div class=\"form-group\"><label for=\"repairerCompany\" class=\"col-md-3 control-label\">Compañía reparadora</label><div class=\"col-md-5\"><input id=\"repairerCompany\" type=\"text\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.repairer_company\"></div></div><div class=\"form-group\"><label for=\"metadata\" class=\"col-md-3 control-label\">Metadatos</label><div class=\"col-md-9\"><textarea id=\"metadata\" rows=\"4\" class=\"form-control\" required=\"\" ng-model=\"vm.newDelivery.metadata\"></textarea></div></div><div class=\"form-group\"><label for=\"settingOverrides\" class=\"col-md-3 control-label\">Configuración de canal</label><div class=\"col-md-9\"><textarea id=\"settingOverrides\" rows=\"4\" class=\"form-control\" ng-model=\"vm.newDelivery.setting_overrides\"></textarea><p class=\"help-block\">Puede sobreescribir los parámetros de configuración de los canales para este envío en concreto. Indique los atributos en formato JSON.</p></div></div><div class=\"form-group\"><label for=\"attachments\" class=\"col-md-3 control-label\">Adjuntos</label><div class=\"col-md-9\"><div class=\"input-group\"><label class=\"input-group-btn\"><span class=\"btn btn-default\">Examinar&hellip; <input type=\"file\" multiple=\"\" style=\"display: none\" base-sixty-four-input=\"\" ng-model=\"vm.selectedFiles\"></span></label> <input type=\"text\" class=\"form-control\" value=\"{{ vm.getSelectedFiles() }}\" readonly=\"\"></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-5\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"newDeliveryForm.$invalid\"><span ng-if=\"vm.ui.creatingDelivery\"><i class=\"fa fa-fw fa-circle-o-notch fa-spin\"></i>Creando envío...</span> <span ng-if=\"! vm.ui.creatingDelivery\">Crear envío</span></button></div></div></form>");
$templateCache.put("app/deliveries/deliveries.html","<div ui-view=\"\"><h1 class=\"page-header\"><span>Envíos</span></h1><div><filtering config=\"vm.filteringConfiguration\" selected-default=\"\'claim_number\'\"></filtering><table class=\"table table-striped\" ng-if=\"vm.deliveries.length > 0\"><thead><tr><th></th><th>Tipo de envío</th><th>Compañía</th><th>Siniestro</th><th>Estado</th><th style=\"width: 18%;\">Fecha y hora</th><th style=\"width: 12%;\">Acciones</th></tr></thead><tbody><tr ng-repeat=\"delivery in vm.deliveries\"><td><a uib-tooltip=\"En respuesta a\" ui-sref=\"root.main.deliveries.detail({deliveryId: delivery.response_to})\" ng-if=\"delivery.response_to !== null\"><i class=\"fa fa-fw fa-arrow-right\"></i></a> <a uib-tooltip=\"Respuesta\" ng-if=\"delivery.response_to === null && delivery.response_delivery !== null\" ui-sref=\"root.main.deliveries.detail({deliveryId: delivery.response_delivery})\"><i class=\"fa fa-fw fa-arrow-left\"></i></a></td><td><a ui-sref=\"root.main.deliveries.detail({deliveryId: delivery.id})\"><span ng-if=\"delivery.delivery_type_id === vm.constants.DELIVERY_TYPE.EVENT.id && delivery.metadata.eventType\">{{ ::delivery.type.name }} - {{ ::delivery.metadata.eventType | translate }}</span> <span ng-if=\"delivery.type.id !== vm.constants.DELIVERY_TYPE.EVENT.id || !delivery.metadata.eventType\">{{ ::delivery.type.name }}</span></a></td><td>{{ ::delivery.company.name }}</td><td>{{ ::delivery.claim_number }}</td><td><span class=\"label {{ vm.getDeliveryStatusBadgeClass(delivery.delivery_status_id) }}\">{{ vm.hbConstants.byId(\'DELIVERY_STATUS\', delivery.delivery_status_id).name }}</span></td><td>{{ ::delivery.created_at | amDateFormat:\'DD/MM/YYYY HH:mm:ss\' }}</td><td><a ng-if=\"vm.canCancelDelivery(delivery)\" class=\"btn btn-warning\" href=\"\" ng-click=\"vm.cancelDelivery(delivery)\" title=\"Cancelar\"><i class=\"fa fa-ban\"></i></a> <a ng-if=\"vm.canRepeatDelivery(delivery)\" class=\"btn btn-primary\" href=\"\" ng-click=\"vm.repeatDelivery(delivery)\" title=\"Repetir\"><i class=\"fa fa-repeat\"></i></a></td></tr></tbody></table><div ng-if=\"vm.deliveries.length > 0\" class=\"text-center\"><div class=\"custom-pagination\"><button ng-if=\"vm.deliveries.metadata.prev_page_url != null\" ng-click=\"vm.previous()\">«</button> <input type=\"text\" ng-model=\"vm.page\" disabled=\"\"> <button ng-if=\"vm.deliveries.metadata.next_page_url != null\" ng-click=\"vm.next()\">»</button></div></div><div class=\"alert alert-info\" ng-if=\"vm.deliveries.length === 0\"><p><i class=\"fa fa-fw fa-info-circle\"></i> No hay ningún envío. Haga click en <strong>Nuevo envío</strong> para crear uno.</p></div></div></div>");
$templateCache.put("app/deliveries/delivery-detail.html","<h1 class=\"page-header\"><div class=\"btn-toolbar pull-right\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-default\" ng-if=\"vm.canRepeatDelivery()\" ng-click=\"vm.repeatDelivery()\"><i class=\"fa fa-fw fa-refresh\"></i>Repetir</button> <button type=\"button\" class=\"btn btn-warning\" ng-if=\"vm.canCancelDelivery()\" ng-click=\"vm.cancelDelivery()\"><i class=\"fa fa-fw fa-ban\"></i>Cancelar</button></div></div><span>Detalles de envío</span></h1><table class=\"table\"><tbody><tr><th>ID</th><td>{{ ::vm.delivery.id }}</td></tr><tr><th>Fecha y hora de creación</th><td>{{ ::vm.delivery.created_at | amDateFormat:\'DD/MM/YY HH:mm:ss\' }}</td></tr><tr><th>Estado</th><td><hb-delivery-status-label status=\"vm.delivery.delivery_status_id\"></hb-delivery-status-label></td></tr><tr><th>Tipo</th><td ng-if=\"vm.delivery.type.id === vm.constants.DELIVERY_TYPE.EVENT.id && vm.delivery.metadata.eventType\">{{ ::vm.delivery.type.name }} - {{ ::vm.delivery.metadata.eventType | translate }}</td><td ng-if=\"vm.delivery.type.id === vm.constants.DELIVERY_TYPE.EVENT.id && !vm.delivery.metadata.eventType\">{{ ::vm.delivery.type.name }}</td><td ng-if=\"vm.delivery.type.id !== vm.constants.DELIVERY_TYPE.EVENT.id\">{{ ::vm.delivery.type.name }}</td></tr><tr><th>Compañía</th><td>{{ ::vm.delivery.company.name }}</td></tr><tr><th>Siniestro</th><td>{{ ::vm.delivery.claim_number }}</td></tr><tr><th>Compañía reparadora</th><td>{{ ::vm.delivery.repairer_company }}</td></tr><tr ng-if=\"vm.delivery.response_to === null && vm.delivery.response_delivery !== null\"><th>Delivery de respuesta</th><td><a ui-sref=\"root.main.deliveries.detail({deliveryId: vm.delivery.response_delivery})\">{{ ::vm.delivery.response_delivery }}</a></td></tr><tr ng-if=\"vm.delivery.response_to !== null\"><th>Delivery en respuesta a</th><td><a ui-sref=\"root.main.deliveries.detail({deliveryId: vm.delivery.response_to})\">{{::vm.delivery.response_to}}</a></td></tr></tbody></table><uib-tabset><uib-tab index=\"0\" heading=\"Intentos\"><h3>Intentos</h3><table class=\"table\" ng-if=\"vm.delivery.attempts.length\"><thead><tr><th>Fecha y hora</th><th>Canal</th><th>Resultado</th></tr></thead><tbody><tr ng-repeat=\"attempt in vm.delivery.attempts\"><td>{{ ::attempt.created_at | amDateFormat:\'DD/MM/YY HH:mm:ss\' }}</td><td>{{ ::attempt.channel.type.name }}</td><td><span class=\"hb-attempt-error label {{ vm.getErrorReasonLabelClass(attempt) }}\" uib-popover=\"{{::attempt.response | limitTo : 100}}{{::attempt.response.length > 100 ? \' ...\' : \'\'}}\" popover-trigger=\"mouseenter\"><i class=\"fa fa-fw fa-warning\"></i>{{ ::attempt.result.name }}</span></td></tr></tbody></table><div class=\"alert alert-info\" ng-if=\"!vm.delivery.attempts.length\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Este envío aún no se ha intentado entregar.</p></div></uib-tab><uib-tab index=\"1\" heading=\"Metadatos y configuración\"><h3>Metadatos</h3><div hljs=\"\" language=\"json\" source=\"vm.getMetadataAsString()\"></div><h3>Ajustes de configuración</h3><div ng-if=\"vm.delivery.setting_overrides\" hljs=\"\" language=\"json\" source=\"vm.getSettingOverridesAsString()\"></div><div class=\"alert alert-info\" ng-if=\"vm.delivery.setting_overrides === null\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No se ha proporcionado configuración específica para este envío.</p></div></uib-tab><uib-tab index=\"2\" heading=\"Adjuntos\"><h3>Adjuntos</h3><table class=\"table\" ng-if=\"vm.delivery.attachments.length\"><thead><tr><th>Fichero</th><th>Tamaño</th></tr></thead><tbody><tr ng-repeat=\"attachment in vm.delivery.attachments\"><td><i class=\"fa fa-fw fa-file-o\"></i> <span ng-if=\"!attachment.url\" uib-popover=\"No disponible\" popover-trigger=\"mouseenter\" style=\"text-decoration: line-through\">{{ ::attachment.filename }}</span> <a ng-if=\"attachment.url\" href=\"{{ ::attachment.url }}\" target=\"_blank\">{{ ::attachment.filename }}</a></td><td>{{ ::attachment.size | hbBytes }}</td></tr></tbody></table><div class=\"alert alert-info\" ng-if=\"!vm.delivery.attachments.length\"><p><i class=\"fa fa-fw fa-info-circle\"></i>Este envío no tiene ningún adjunto.</p></div></uib-tab><uib-tab index=\"3\" heading=\"Respuesta\"><h3>Respuesta</h3><div ng-if=\"vm.delivery.response\" hljs=\"\" language=\"json\" source=\"vm.getResponseAsString()\"></div><div class=\"alert alert-info\" ng-if=\"vm.delivery.response === null\"><p><i class=\"fa fa-fw fa-info-circle\"></i>No hay respuesta para este envío</p></div></uib-tab></uib-tabset><script type=\"text/ng-template\" id=\"app/deliveries/repeat-delivery-confirmation-modal.html\"><div class=\"modal-header\"> <h3 class=\"modal-title\">¿Repetir envío?</h3> </div> <div class=\"modal-body\"> <p>Parece que este envío ya ha sido entregado con éxito. ¿Desea repetirlo en cualquier caso?</p> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancel()\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Sí, repetir envío</button> </div></script>");
$templateCache.put("app/main/main.html","<div class=\"container main-layout\"><nav class=\"navbar navbar-default\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"#\"><img class=\"pull-left\" src=\"assets/images/logo.png\" alt=\"LDA Hub\"> <span>Veryeasy Hub</span></a></div><div class=\"collapse navbar-collapse\" id=\"navbar\"><ul class=\"nav navbar-nav navbar-right\"><li uib-dropdown=\"\"><a href=\"#\" uib-dropdown-toggle=\"\"><i class=\"fa fa-fw fa-user\"></i>{{ vm.hbSession.get().username }} <b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li><a href=\"#\" ng-click=\"vm.logout()\"><i class=\"fa fa-fw fa-sign-out\"></i>Cerrar sesión</a></li></ul></li></ul></div></div></nav><div class=\"row\"><div class=\"col-md-3\"><ca-menu header=\"Menú principal\"></ca-menu><ca-menu header=\"Administración\" category=\"admin\"></ca-menu></div><div class=\"col-md-9\"><div class=\"panel panel-default\" style=\"position: relative;\"><ca-loading-overlay></ca-loading-overlay><div class=\"panel-body\" ui-view=\"\"></div></div></div></div></div>");
$templateCache.put("app/components/channel-status-icon/channel-status-icon.html","<span><i class=\"fa fa-fw fa-circle text-{{ ::vm.getTextClass() }}\" uib-tooltip=\"{{ ::vm.getStatusName() }}\"></i></span>");
$templateCache.put("app/components/delivery-status-label/delivery-status-label.html","<span class=\"label label-{{ vm.getLabelClass() }}\">{{ vm.getStatusName() }}</span>");
$templateCache.put("app/components/filtering/filtering.html","<div class=\"filtering row panel panel-default\"><div class=\"col-md-12 panel-body\"><div class=\"row\"><div class=\"col-md-4\"><select class=\"form-control\" ng-model=\"vmFiltering.selectedField\" ng-change=\"vmFiltering.selectedValue = null\" ng-options=\"configEntry as configEntry.field for configEntry in vmFiltering.config\" required=\"\"><option value=\"\" disabled=\"\">Campo a filtrar</option></select></div><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" ng-if=\"vmFiltering.selectedField.type === \'text\'\" ng-model=\"vmFiltering.selectedValue\" placeholder=\"Valor\"><select class=\"form-control\" ng-if=\"vmFiltering.selectedField.type === \'select\'\" ng-model=\"vmFiltering.selectedValue\" ng-options=\"value.id as value.name for value in vmFiltering.selectedField.values\" required=\"\"><option value=\"\" disabled=\"\">Valor</option></select><div class=\"input-group\" ng-if=\"vmFiltering.selectedField.type === \'date\'\"><input type=\"text\" name=\"dateInput\" class=\"form-control\" uib-datepicker-popup=\"dd-MM-yyyy\" datepicker-options=\"vmFiltering.datepickerOptions\" ng-model=\"vmFiltering.selectedValue\" is-open=\"vmFiltering.ui.dateInput\" current-text=\"Hoy\" clear-text=\"Borrar\" close-text=\"Salir\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vmFiltering.openDatepicker(\'dateInput\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-md-2\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"vmFiltering.selectedValue === null\" ng-click=\"vmFiltering.addFilter()\">Añadir filtro</button></div></div><hr class=\"m-t\"><div class=\"row\"><div class=\"col-md-12\"><div ng-repeat=\"configEntry in vmFiltering.config\" ng-if=\"configEntry.selectedValues.length\"><label>{{configEntry.field}}</label> <span ng-repeat=\"value in configEntry.selectedValues\" ng-click=\"vmFiltering.removeFilter(configEntry, value)\" style=\"cursor:pointer;\"><span class=\"label label-default\" ng-if=\"configEntry.type === \'boolean\'\">{{value == \'1\' ? \'yes\' : \'no\' | translate | capitalize}} <i class=\"fa fa-times\"></i></span>&nbsp; <span class=\"label label-default\" ng-if=\"configEntry.type !== \'boolean\'\">{{vmFiltering.displayValue(configEntry, value)}} <i class=\"fa fa-times\"></i></span>&nbsp;</span></div></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");}]);